define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var TransferViewController = require('web-agent-viewControllers/TransferViewController');
    var ChatViewController = require('web-agent-viewControllers/ChatViewController');
    var RichTextChatInputViewController = require('web-agent-viewControllers/RichTextChatInputViewController');
    var DropdownViewController = require('web-agent-viewControllers/DropdownViewController');
    var PrivateMessageDialogViewController = require('web-agent-viewControllers/PrivateMessageDialogViewController');
    var ContentPreviewDialogViewController = require('web-agent-viewControllers/ContentPreviewDialogViewController');
    var UnformattedTextChatDialogViewController = require('web-agent-viewControllers/UnformattedTextChatDialogViewController');
    var TakeOverViewController = require('web-agent-viewControllers/TakeOverViewController');
    var AvatarViewController = require('web-agent-components/AvatarViewController');
    var DialogManager = require('web-agent-utils/DialogManager');
    var TabsManagerViewController = require('web-agent-viewControllers/TabsManagerViewController');
    var SlaChangerViewController = require('web-agent-viewControllers/SlaChangerViewController');
    var FileSharingViewController = require('web-agent-viewControllers/FileSharingViewController');
    var IdnvViewController = require('web-agent-viewControllers/IdnvViewController');
    var CoAppInviteViewController = require('web-agent-viewControllers/CoAppInviteViewController');
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var StructuredContentManager = require('web-agent-utils/StructuredContentManager');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var SchemaValidator = require('web-agent-utils/SchemaValidator');
    var PredefinedContentMacroUtils = require("web-agent-utils/PredefinedContentMacroUtils");
    var FilePreviewDialogViewController = require('web-agent-viewControllers/FilePreviewDialogViewController');
    var userProfilesPath = 'userProfiles.';

    var EngagementViewController = ViewController.extend({
        ControllerName: 'EngagementViewController',

    LPViewMap: {
        engagementState: '.lpview_engagement_state',
        visitorName: '.lpview_visitor_name',
        visitorSerialNumber: '.lpview_visitor_serial_number',
        transferPlaceholder: '.lpview_transfer_widget',
        privateMessagePlaceholder: '.lpview_private_message',
        takeOverPlaceholder: '.lpview_take_over_engagement',
        engagementArea: '.lpview_engagement_area',
        engagementTime: '.lpview_engagement_time',
        engagementSentiment: '.lpview_visitor_sentiment',
        device: '.lpview_visitor_device',
        engagementHeader: '.lpview_engagement_header',
        engagementActionsArea: '.lpview_action_area',
        endEngagementMenuItem: '.lpview_endEngagement_engagement_menu_item',
        transferEngagementMenuItem: '.lpview_transfer_engagement_menu_item',
        privateMessageMenuItem: '.lpview_private_message_menu_item',
        itemText: '.item_title',
        hotkeyTooltipTransfer: '.lpview_hotkey_tooltip_transfer',
        hotkeyTooltipClose: '.lpview_hotkey_tooltip_close',
        unformattedTextPlaceholder: '.lpview_unformatted_text',
        contentPreviewPlaceHolder: '.lpview_content_preview',
        urgentContainer: '.lpview_badges_view_container_urgent',
        firstTimeContainer: '.lpview_badges_view_container_first_time',
        overdueContainer: '.lpview_badges_view_container_overdue',
        inQueueContainer: '.lpview_badges_view_container_in_queue',
        authChat: '.auth_chat',
        resolved: '.lpview_icon_resolved',
        resolvedContainer: '.lpview_icon_resolved_view_container',
        dialogPlaceholder: '.lpview_file_preview',
    visitorPresence: ".visitor_presence"},

        LPClassesMap: {
            loading: 'loading',
            noChatInput: 'no_chat_input',
            disable: 'disable',
            myChat: 'myChat',
            spectated: 'spectated',
            error: 'error',
            negative: 'negative',
            positive: 'positive',
            neutral: 'neutral',
            devicePrefix: 'device-',
            desktop: 'desktop',
            tablet: 'tablet',
            messaging: 'messaging',
            mobile: 'mobile',
            reader: 'reader',
            manager: 'manager',
            true: 'true',
            false: 'false',
            active: 'active',
            onlinePresenceEnabled: "online_presence_enabled",
            onlinePresence: "online_presence",
            noPresenceStatus: "no_presence_status"
        },

        initialize: function (constructorData) {
            this.singleton = constructorData.singleton;
            this.visitorId = constructorData.visitorId;
            this.chatsRootModelPath = constructorData.chatsRootModelPath + '.' || 'chats.';
            this.bindToChatModel = constructorData.bindToChatModel;
            this.widgetMode = constructorData.widgetMode || 'Visitor';
            this.tableName = constructorData.tableName;
            this.activeEngagement = true;
            this.activeMenuItems = [];
            this.isOnlinePresenceEnabled = lpTag.WebAgent.logicController.getOnlinePresenceSiteSetting().enabled;
            this.participantRoles = lpTag.AMSStatics.participant.roles;
            this.loadingTimeoutRef = null;

            this.engagementType = constructorData.engagementType;

            this.dropdownActionsMenu = new DropdownViewController({
                templateFile: 'LP_dropdown_actions_menu.html',
                context: this
            });
            this.avatar = new AvatarViewController({
                templateFile: 'LP_avatar_base.html',
                context: this,
                modelController: this.modelController,
                wrapWithDiv: false,
                consumerId: this.visitorId,
                isSingleton: this.singleton
            });
            this.addViewController({
                viewController: this.dropdownActionsMenu,
                target: this.LPViewMap.engagementActionsArea
            });

            this.addViewController({ viewController: this.avatar, target: ".lpview_avatar_container" });
            this.engagementStartTime = 0;

            if (this.widgetMode === "History") {
                this.initHistoryEngagementMode();
            }
        },

        events: function () {
            if (this.widgetMode === 'Visitor' && !this.singleton && this.visitorId) { // making sure we bound to the visitor only if not in singleton (instance per visitor mode)
                this.bindVisitorId(this.visitorId);
            }
            if (this.widgetMode === 'Visitor' && this.singleton) {
                this.viewEventsHandler.bindEvent({
                    appName: this.tableName,
                    UIEvent: this.eventType.TABLE_WIDGETS_CLOSED,
                    callback: this.onWidgetsClosed
                });
            }
            this.bindModel({modelPath: 'agent.status', callback: this.statusChanged});
            this.bindModel({modelPath: 'agent.connectionState', callback: this.handleConnectionStatusChanged});
            this.bindModel({modelPath: 'amsService.socketState', callback: this.handleConnectionStatusChanged});
            this.bindModel({
                modelPath: 'participants.myEngagements.' + this.visitorId + '.agentInfo.allParticipantsHash',
                callback: this.handleParticipantsChange
            });

            this.viewEventsHandler.bindEvent({
                appName: this.visitorId,
                UIEvent: this.eventType.WIDGET_CONTENT_SEND,
                callback: this.handleMessageFromWidget,
            });
        },

        render: function () {
        }
    });

    EngagementViewController.prototype.engagementStates = {
        active: { tag: 'active', cssClass: 'active_engagement' },
        inactive: { tag: 'inactive', cssClass: 'passive_engagement' },
        completed: { tag: 'completed', cssClass: 'passive_engagement' }
    };

    EngagementViewController.prototype.handleParticipantsChange = function () {
        this.setDropDownAndShortcuts();
    };
    /**
     * Create the DropDown menu items and register shortcuts based on the current state.
     */
    EngagementViewController.prototype.setDropDownAndShortcuts = function (isRemoval) {
        var valuesMap = getCurrentState.call(this);
        var menuDefinition = this.getMenuItemsDefinition();
        var activeMenuItems = getActiveMenuItems();

        if (this.supportShortcuts) {
            // Removing old shortcuts
            updateShortcuts(this.activeMenuItems, this.unregisterShortcut.bind(this));
        }

        if (isRemoval) {
            return;
        }

        // set's the new active menu.
        this.activeMenuItems = activeMenuItems;

        // update the drop down with the new menu preset.
        this.dropdownActionsMenu.updateDropdownData(this.activeMenuItems);

        // Toggle the disabled button's in the menu.
        for (var i = 0; i < this.activeMenuItems.length; i++) {
            var disabledConditions = this.activeMenuItems[i].conditions && this.activeMenuItems[i].conditions.disabled;
            if (disabledConditions && validateConditions(this.activeMenuItems[i].conditions.disabled)) {
                this.dropdownActionsMenu.toggleDropdownItem(this.activeMenuItems[i].actionName, false);
            } else if (this.supportShortcuts) {
                // updating the new shortcuts.
                updateShortcut(this.activeMenuItems[i], this.registerShortcut.bind(this));
            }
        }


        function validateConditions(conditions) {
            for (var i = 0; i < conditions.length; i++) {
                if (isValidCondition(conditions[i])) {
                    return true;
                }
            }
            return false;

            function isValidCondition(cSet) {
                for (var key in cSet) {
                    if (valuesMap.hasOwnProperty(key)) {
                        var condition = cSet[key];
                        var value = valuesMap[key];
                        if (condition !== value) {
                            return false;
                        }
                    }
                }
                return true;
            }
        }

        function getCurrentState() {
            var isOwnerAgent, ownerAgentId, isJoinedAsManager;
            var isMessaging = lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId, this.chatsRootModelPath);
            var engagementState = lpTag.WebAgent.logicController.getEngagementStateByChatId(this.chatId, this.chatsRootModelPath);
            var isSpectate = lpTag.WebAgent.logicController.isSpectatedEngagementByChatId(this.chatId, this.chatsRootModelPath);
            var isAcceptedEngagement = lpTag.WebAgent.logicController.isAcceptedEngagementByChatId(this.chatId, this.chatsRootModelPath);
            var isHistoryMode = this.widgetMode === "History";
            var badges = this.modelController.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo.badges');
            var isInSurvey = badges && badges.in_survey;
            var isNoActiveDialog = badges && badges.no_active_dialog;

            if (isMessaging) {
                ownerAgentId = this.modelController.getModelParam(this.chatsRootModelPath + this.chatId + '.agentInfo.messagingUserId');
                isOwnerAgent = ownerAgentId == this.modelController.getModelParam('agent.messagingUserId');
                var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath);
                isJoinedAsManager = activeDialogId && lpTag.WebAgent.logicController.isLoggedInAgentManagerParticipant(this.chatId, activeDialogId, this.chatsRootModelPath);
            } else {
                ownerAgentId = this.modelController.getModelParam(this.chatsRootModelPath + this.chatId + '.agentInfo.agentId') + '';
                isOwnerAgent = ownerAgentId == this.modelController.getModelParam('agent.id');
            }


            var isInQueue = _.isEmpty(ownerAgentId);
            var isActiveParticipant = isAcceptedEngagement || isJoinedAsManager;
            var isActiveEngagement = engagementState === this.engagementStates.active.tag;
            var isPermittedToTakeover = lpTag.WebAgent.logicController.canTakeoverConversation();

            return {
                isInSurvey: isInSurvey,
                isNoActiveDialog: isNoActiveDialog,
                isMessaging: isMessaging,
                isRealTime: !isMessaging,
                isSingleton: !!this.singleton,
                isSpectate: !!isSpectate,
                isAcceptedEngagement: !!isAcceptedEngagement,
                isJoinedAsManager: !!isJoinedAsManager,
                isOwnerAgent: !!isOwnerAgent,
                isInQueue: !!isInQueue,
                isActiveParticipant: !!isActiveParticipant,
                isHistoryMode: !!isHistoryMode,
                isActiveEngagement: !!isActiveEngagement,
                isPermittedToTakeover: isPermittedToTakeover
            };
        }

        function updateShortcut(menuItem, handler) {
            if (menuItem.shortcuts && menuItem.shortcuts.length) {
                var aShortcuts = menuItem.shortcuts;
                for (var j = 0; j < aShortcuts.length; j++) {
                    var sItem = aShortcuts[j];
                    handler(sItem.type, sItem.callback, sItem.options);
                }
            }
        }

        function updateShortcuts(menuItems, handler) {
            for (var i = 0; i < menuItems.length; i++) {
                updateShortcut(menuItems[i], handler);
            }
        }

        function getActiveMenuItems() {
            var activeMenuItems = [];
            for (var i = 0; i < menuDefinition.length; i++) {
                var menuItem = menuDefinition[i];
                // validate condition for visibility
                if (typeof menuItem.conditions === 'undefined' || validateConditions(menuItem.conditions.visible)) {
                    activeMenuItems.push(menuItem);
                }
            }
            return activeMenuItems;
        }
    };

    EngagementViewController.prototype.setSingletonSpectateDropdownMenu = function () {
        this.setDropDownAndShortcuts();
    };

    EngagementViewController.prototype.getMenuItemsDefinition = function () {
        return [
            {
                actionName: 'openEngagement',
                callback: this.openEngagementClicked,
                conditions: {
                    visible: [{ isSingleton: true, isRealTime: true, isHistoryMode: false }]
                },
                shortcuts: [{ type: this.shortcutType.ACCEPT_NEXT_CHAT, callback: this.openEngagementClicked }]
            },
            {
                actionName: 'openConversation',
                callback: this.openEngagementClicked,
                conditions: {
                    visible: [
                        { isSingleton: true, isMessaging: true }
                    ]
                },
                shortcuts: [{ type: this.shortcutType.ACCEPT_NEXT_CHAT, callback: this.openEngagementClicked }]
            },
            {
                actionName: 'hideConversation',
                callback: this.hideEngagement,
                conditions: {
                    visible: [
                        { isSingleton: false, isMessaging: true },
                        { isSingleton: false, isRealTime: true, isActiveEngagement: false },
                        { isSingleton: false, isRealTime: true, isSpectate: true }
                    ]
                },
                shortcuts: [{ type: this.shortcutType.HIDE_CONVERSATION, callback: this.hideEngagement }]
            },
            {
                actionName: 'unformatted_text_copyToClipboard',
                callback: this.showUnformattedTextClicked,
                conditions: {
                    visible: [{ isRealTime: true }, { isMessaging: true }]
                }
            },
            {
                actionName: 'privateMessage',
                callback: this.showPrivateMessageDialogClicked,
                conditions: {
                    visible: [{ isRealTime: true, isActiveEngagement: true }]
                }
            },
            {
                actionName: 'returnToQueue',
                callback: this.returnToQueue,
                conditions: {
                    visible: [{
                        isSingleton: false,
                        isMessaging: true,
                        isActiveParticipant: true,
                        isActiveEngagement: true,
                        isInSurvey: false,
                        isNoActiveDialog: false
                    }],
                    disabled: [{ isInQueue: true }, { isInQueue: false, isActiveParticipant: false }]
                },
                shortcuts: [{ type: this.shortcutType.RETURN_TO_QUEUE, callback: this.returnToQueue }]
            },
            {
                actionName: 'transfer',
                callback: this.transferEngagementClicked,
                conditions: {
                    visible: [
                        { isSingleton: false, isRealTime: true, isActiveEngagement: true, isAcceptedEngagement: true }
                    ],
                    disabled: [{ isActiveParticipant: false }, { isInQueue: true }]
                },
                shortcuts: [{ type: this.shortcutType.TRANSFER_ENGAGEMENT, callback: this.transferShortcutClicked }]
            },
            {
                actionName: 'transferConversation',
                callback: this.transferEngagementClicked,
                conditions: {
                    visible: [
                        { isSingleton: false, isMessaging: true, isActiveEngagement: true, isActiveParticipant: true, isInSurvey: false, isNoActiveDialog: false }
                    ],
                    disabled: [{ isActiveParticipant: false }]
                },
                shortcuts: [{ type: this.shortcutType.TRANSFER_CONVERSATION, callback: this.transferShortcutClicked }]
            },
            {
                actionName: 'leaveConversation',
                callback: this.leaveConversation,
                conditions: {
                    visible: [{ isSingleton: false, isJoinedAsManager: true, isActiveEngagement: true }]
                }
            },
            {
                actionName: 'endEngagement',
                callback: this.endEngagementClicked,
                conditions: {
                    visible: [{ isSingleton: false, isRealTime: true, isActiveEngagement: true, isOwnerAgent: true }]
                },
                shortcuts: [{
                    type: this.shortcutType.CLOSE_ENGAGEMENT, callback: this.endEngagementClicked
                }]
            },
            {
                actionName: 'closeConversation',
                callback: this.closeConversation,
                conditions: {
                    visible: [{
                        isSingleton: false,
                        isMessaging: true,
                        isActiveEngagement: true,
                        isActiveParticipant: true,
                        isInSurvey: false,
                        isNoActiveDialog: false
                    }]
                },
                shortcuts: [{
                    type: this.shortcutType.CLOSE_CONVERSATION, callback: this.closeConversation
                }]
            },
            {
                actionName: 'takeover',
                callback: this.takeOverConversation,
                conditions: {
                    visible: [
                        {
                            isSingleton: false,
                            isMessaging: true,
                            isActiveEngagement: true,
                            isOwnerAgent: false,
                            isPermittedToTakeover: true,
                            isInQueue: false,
                            isInSurvey: false,
                            isNoActiveDialog: false
                        }
                    ]
                }
            }
        ];
    };

    EngagementViewController.prototype.initHistoryEngagementMode = function () {
        this.addUnformattedTextDialog({ chatId: this.chatId, chatsRootModelPath: this.chatsRootModelPath });
        this.addContentPreviewDialog();
        this.addTakeOverDialog({ chatId: this.chatId, chatsRootModelPath: this.chatsRootModelPath });
        this.setDropDownAndShortcuts();
        this.initDialogManager();
    };

    EngagementViewController.prototype.initDialogManager = function () {
        if (!this.DialogManager) {

            // define the hide here, no access to the transfer view at init time, not always available
            // assuming that the transfer view instance is available if called.
            var hideTransferEngagementHandler = function () {
                if (this.transferView) {
                    this.transferView.lpHide();
                }
            };

            // transfer to prototype function.
            var showTransferEngagementHandler = function () {
                if (this.transferView) {
                    this.transferView.lpShow();
                }
            };

            this.DialogManager = new DialogManager({
                context: this,
                dialogs: {
                    "privateMessage": {
                        viewController: this.privateMessageDialog
                    },
                    "unformattedText": {
                        viewController: this.unformattedTextDialog
                    },
                    "transfer": {
                        showDialog: showTransferEngagementHandler,
                        hideDialog: hideTransferEngagementHandler
                    },
                    "contentPreview": {
                        viewController: this.contentPreviewDialog
                    },
                    "takeOverConversation": {
                        viewController: this.takeOverDialog
                    }
                }
            });
        }
    };

    EngagementViewController.prototype.bindVisitorId = function (visitorId) {
        this.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_DISPOSED,
            callback: this.visitorDisposed
        });
        this.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_FOCUSED,
            callback: this.lpFocus
        });
        this.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_BLURRED,
            callback: this.lpBlur
        });
        this.viewEventsHandler.bindEvent({
            appName : visitorId,
            UIEvent : this.eventType.SHOW_FILE_UPLOAD_PREVIEW,
            callback : this.showPreview
        });

        //[ElaA. 2/2/13] the order between those two next line is important for the dropdownViewController and transferViewController functionality
        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
        this.bindModel({ modelPath: participantPath + '.chats', callback: this.updateChatId });
        this.bindModel({
            modelPath: participantPath + '.participantState.engagementState',
            callback: this.handleEngagementStateChanged
        });
        this.bindModel({
            modelPath: participantPath + '.participantInfo.acceptedEngagement',
            callback: this.handleAcceptedEngagement
        });
        if (lpTag.WebAgent.logicController.hasSentimentAnalysisFeature()) {
            this.bindModel({
                modelPath: participantPath + '.participantInfo.sentimentScore',
                callback: this.updateEngagementSentiment
            });
        }
        var infoPath = lpTag.WebAgent.logicController.getParticipantDataPath(visitorId);
        this.bindModel({ modelPath: infoPath + '.data.deviceFamily', callback: this.updateDevice });

        if (lpTag.WebAgent.logicController.isVisitorAsyncMessaging(visitorId)) {
            //bind to the badges
            this.bindModel({modelPath: 'userProfiles.' + visitorId + '.participant.isAuthenticated', callback: this.showAuthChatIcon});
            this.bindModel({ modelPath: userProfilesPath + visitorId + '.fullName', callback: this.handleParticipantNameUpdated});
            this.bindModel({ modelPath: userProfilesPath + visitorId + '.imgUrl', callback: this.handleParticipantAvatarUpdated });
        }
        else {
            //bind to the badges
            this.bindModel({
                modelPath: infoPath + '.data.participant.isAuthenticated',
                callback: this.showAuthChatIcon
            });
        }

        //bind for the reseting of the engagement if needed
        this.bindModel({
            modelPath: 'participants.myEngagements.' + visitorId + '.participantState.engagementState',
            callback: this.handleEngagementsChanged
        });
        this.bindModel({
            modelPath: 'participants.myEngagements.' + visitorId + '.participantInfo.acceptedEngagement',
            callback: this.handleEngagementsChanged
        });
    };

    EngagementViewController.prototype.unbindVisitorId = function () {
        this.viewEventsHandler.unbindEvent({
            appName: this.visitorId,
            UIEvent: this.eventType.VISITOR_DISPOSED,
            callback: this.visitorDisposed
        });
        this.viewEventsHandler.unbindEvent({
            appName: this.visitorId,
            UIEvent: this.eventType.VISITOR_FOCUSED,
            callback: this.lpFocus
        });
        this.viewEventsHandler.unbindEvent({
            appName: this.visitorId,
            UIEvent: this.eventType.VISITOR_BLURRED,
            callback: this.lpBlur
        });
        this.viewEventsHandler.unbindEvent({
            appName : this.visitorId,
            UIEvent : this.eventType.SHOW_FILE_UPLOAD_PREVIEW,
            callback : this.showPreview
        });

        //[ElaA. 2/2/13] the order between those two next line is important for the dropdownViewController and transferViewController functionality
        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
        this.unbindModel({ modelPath: participantPath + '.chats', callback: this.updateChatId });
        this.unbindModel({
            modelPath: participantPath + '.participantState.engagementState',
            callback: this.handleEngagementStateChanged
        });
        this.unbindModel({
            modelPath: participantPath + '.participantInfo.acceptedEngagement',
            callback: this.handleAcceptedEngagement
        });
        if (lpTag.WebAgent.logicController.hasSentimentAnalysisFeature()) {
            this.unbindModel({
                modelPath: participantPath + '.participantInfo.sentimentScore',
                callback: this.updateEngagementSentiment
            });
        }
        var infoPath = lpTag.WebAgent.logicController.getParticipantDataPath(this.visitorId);
        this.unbindModel({ modelPath: infoPath + '.data.deviceFamily', callback: this.updateDevice });

        if (lpTag.WebAgent.logicController.isVisitorAsyncMessaging(this.visitorId)) {
            //unbind to the badges
            this.unbindModel({modelPath: 'userProfiles.' + this.visitorId + '.participant.isAuthenticated', callback: this.showAuthChatIcon});
            this.unbindModel({ modelPath: userProfilesPath + this.visitorId + '.fullName', callback: this.handleParticipantNameUpdated});
            this.unbindModel({ modelPath: userProfilesPath + this.visitorId + '.imgUrl', callback: this.handleParticipantAvatarUpdated});
        }
        else {
            //unbind to the badges
            this.unbindModel({
                modelPath: infoPath + '.data.participant.isAuthenticated',
                callback: this.showAuthChatIcon
            });
        }

        //unbind for the love of god
        this.unbindModel({
            modelPath: 'participants.myEngagements.' + this.visitorId,
            callback: this.handleEngagementsChanged,
            deepBind: true
        });
    };

    EngagementViewController.prototype.addUnformattedTextDialog = function (options) {
        if (!this.unformattedTextDialog) {
            this.unformattedTextDialog = new UnformattedTextChatDialogViewController({
                chatId: options.chatId,
                modelController: this.modelController,
                templateFile: 'LP_unformatted_text_dialog.html',
                chatsRootModelPath: options.chatsRootModelPath,
                hidden: true
            });
            this.addViewController({
                viewController: this.unformattedTextDialog,
                target: this.LPViewMap.unformattedTextPlaceholder
            });
        }
        else {
            this.unformattedTextDialog.updateChatId(options.chatId);
        }

    };

    EngagementViewController.prototype.addTakeOverDialog = function (options) {
        if (!this.takeOverDialog) {
            this.takeOverDialog = new TakeOverViewController({
                chatId: options.chatId,
                modelController: this.modelController,
                templateFile: 'LP_take_over_dialog.html',
                chatsRootModelPath: options.chatsRootModelPath,
                hidden: true
            });
            this.addViewController({
                viewController: this.takeOverDialog,
                target: this.LPViewMap.takeOverPlaceholder
            });
        }
        else {
            this.takeOverDialog.updateChatId(options.chatId);
        }
    };

    EngagementViewController.prototype.ensurePartialResolved = function () {
        // History (AllConnection) Widget handle the partial information,
        // this is only for instance mode.
        if(this.widgetMode === "History"){
            return; // DO not support history modes.
        }
        var context = this;
        var isPartialModelKey;
        clearTimeout(this.loadingTimeoutRef);
        if (this.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo.state') === lpTag.WebAgent.logicController.chatStates.ended) {
            isPartialModelKey = this.chatsRootModelPath + this.chatId + '.isPartial';
            var isPartial = this.getModelParam(isPartialModelKey);
            if (isPartial) {
                this.setLoading();
                this.bindModel({
                    modelPath: isPartialModelKey,
                    callback: onIsPartialChange
                });
                this.loadingTimeoutRef = setTimeout(onTimeOut, 50000); // long timeout as there are some retries
            }
        }

        function onTimeOut() {
            if(context && !context.disposed){
                context.setEngagementAreaErrorState();
            }
            context.unbindModel({
                modelPath: isPartialModelKey,
                callback: onIsPartialChange
            });
        }

        function onIsPartialChange(data) {
            if(data && data.newValue === false){
                clearTimeout(this.loadingTimeoutRef);
                context.removeLoading();
                context.removeEngagementAreaErrorState();
                context.unbindModel({
                    modelPath: isPartialModelKey,
                    callback: onIsPartialChange
                });
            }
        }
    };

//Re-render the engagement is specific cases that concern split sessions, transfers and spectate.
    EngagementViewController.prototype.handleEngagementsChanged = function (eventData) {
        var context = this;
        if (eventData) {

            var newAcceptedByMe;
            var currentAcceptedByMe;
            var newEngagementState;
            var currentEngagementState;

            //var command = getCommandFromKey(eventData.key);
            var visitorId = this.visitorId || getVisitorIdFromEventData(eventData.key); //for cases where the engagement is not displayed yet

            if (isReopenedEngagement(eventData)) {
                newEngagementState = eventData.newValue;
                currentEngagementState = eventData.oldValue;
                currentAcceptedByMe = lpTag.WebAgent.logicController.isAcceptedEngagementByChatId(this.chatId);
            } else if (isChangeInAssignee(eventData)) {
                newAcceptedByMe = eventData.newValue;
                currentAcceptedByMe = !!eventData.oldValue;
                currentEngagementState = lpTag.WebAgent.logicController.getEngagementStateByChatId(this.chatId);
            }

            //The 2 cases in which we re-render
            if ((!!newAcceptedByMe && !currentAcceptedByMe && newAcceptedByMe !== currentAcceptedByMe && currentEngagementState === "active") ||                 //If there was a change in assignee to an active engagement
                (newEngagementState === "active" && (currentEngagementState === "completed" || currentEngagementState === "inactive") && currentAcceptedByMe)) {  //or if there was a change in state to my engagement

                //save the myEngagements obj
                var myEngagementsChatObj = lpTag.WebAgent.logicController.getModelParam("participants.myEngagements." + visitorId);
                var chatsObj = {};
                if (myEngagementsChatObj && myEngagementsChatObj.chats) { //save all instances of split session
                    for (var chatId in myEngagementsChatObj.chats) {
                        chatsObj[chatId] = lpTag.WebAgent.logicController.getModelParam("chats." + chatId);
                    }
                }

                //take the split session and do the custom variable thing
                var splitSessionDataObj = lpTag.WebAgent.logicController.getModelParam("participants.info." + visitorId + ".data.splitSession");
                if (splitSessionDataObj) {
                    var customVariablesDataObj = lpTag.WebAgent.logicController.getModelParam("participants.info." + visitorId + ".data.customVariables");
                    splitSessionDataObj = splitSessionDataObj.concat(customVariablesDataObj);
                    this.modelController.setModelParam("participants.info." + visitorId + ".data.customVariables", splitSessionDataObj);
                }

                //hide conversation. it will remove from myEngagements
                lpTag.WebAgent.logicController.hideEngagement(this.chatId, visitorId, chatsObj, myEngagementsChatObj);
            }
        }

        function getVisitorIdFromEventData(key) {
            return new RegExp(/(\w+)$/g, key);
        }

        function isReopenedEngagement(eventData) {
            if (eventData.newValue && eventData.oldValue) {
                return (eventData.newValue === "active" && (eventData.oldValue === "inactive" || eventData.oldValue === "completed"));
            }
            return false;
        }

        function isChangeInAssignee(eventData) {
            if (eventData.newValue) {
                return (eventData.newValue && (eventData.oldValue === undefined || eventData.oldValue === false));
            }
            return false;
        }
    };

    EngagementViewController.prototype.showUnformattedTextClicked = function () {
        this.DialogManager.showDialog('unformattedText');
    };

    EngagementViewController.prototype.showPrivateMessageDialogClicked = function () {
        this.DialogManager.showDialog('privateMessage');
    };

    EngagementViewController.prototype.transferShortcutClicked = function () {
        this.DialogManager.showDialog('transfer');
    };

    EngagementViewController.prototype.visitorDisposed = function () {
        this.unbindChatModel();
        this.unbindVisitorId();
        this.dispose();
    };

    EngagementViewController.prototype.transferDisposed = function () {
        if (this.transferView) {
            this.transferView.dispose();
            this.transferView = null;
        }
    };

    EngagementViewController.prototype.setEngagementColor = function (data) {
        if (this.view && this.view.firstChild && (data.newValue || data.newValue === '')) { // the === '' is for Spectate mode!
            if (this.participantTag) {
                this.removeClass(this.view.firstChild, this.participantTag);
            }
            this.participantTag = data.newValue;
            this.addClass(this.view.firstChild, this.participantTag);
        }
    };

    EngagementViewController.prototype.resetEngagementColor = function () {
        this.setEngagementColor({ newValue: '' });
    };

    EngagementViewController.prototype.resetParticipantsClassnames = function () {
        this.removeClass(this.LPViewMap.engagementHeader, this.LPClassesMap.reader);
        this.removeClass(this.LPViewMap.engagementHeader, this.LPClassesMap.manager);
    };

    EngagementViewController.prototype.resetResolvedClassnames = function () {
        var resolvedContainer = this.getFirstElement(this.LPViewMap.resolvedContainer);
        if (resolvedContainer) {
            this.removeClass(resolvedContainer, this.LPClassesMap.active);
        }
        var resolved = this.getFirstElement(this.LPViewMap.resolved);
        if (resolved) {
            this.removeClass(resolved, [this.LPClassesMap.true, this.LPClassesMap.false]);
        }
    };

    EngagementViewController.prototype.transferEngagementClicked = function () {
        this.addTransferView(this.chatId);
        this.DialogManager.showDialog('transfer');
    };

    EngagementViewController.prototype.takeOverConversation = function () {
        this.DialogManager.showDialog('takeOverConversation');
    };

    EngagementViewController.prototype.endEngagementClicked = function (e) {
        this.stopPropagation(e);
        this.touchSession();


        if (lpTag.WebAgent.logicController.isSpectatedEngagement(this.visitorId)) {
            this.hideEngagement();
        } else if (this.activeEngagement) { // Send an en event to the chat
            this.endActiveEngagement();
        } else {
            this.removeEngagement();
        }
    };

    EngagementViewController.prototype.removeEngagement = function () {
        if (this.engagementState === this.engagementStates.completed.tag || lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId)) {
            this.hideEngagement();
        } else {
            this.showDialog({
                title: this.translate('surveySubmitRequiredTitle'),
                description: this.translate('surveySubmitRequiredDescription'),
                okButton: this.translate('surveySubmitRequiredOkButton'),
                cancelButton: this.translate('surveySubmitRequiredCancelButton'),
                okCallback: this.hideEngagement, //close engagement
                cancelCallback: this.disconnectCancelClicked, //go back to submit
                dismissCallback: this.disconnectCancelClicked,
                targetView: window.MainViewControllerBody
            });
        }
    };

    EngagementViewController.prototype.endActiveEngagement = function () {
        this.showDialog({
            title: this.translate('endEngagementTitle') + " '" + this.visitorName + "'",
            description: this.translate('endEngagementDescription'),
            okButton: this.translate('endEngagement'),
            cancelButton: this.translate('cancel'),
            okCallback: this.moveToInactiveOkClicked,
            cancelCallback: this.disconnectCancelClicked, //go back to submit
            dismissCallback: this.disconnectCancelClicked,
            targetView: window.MainViewControllerBody
        });
    };

    EngagementViewController.prototype.moveToInactiveOkClicked = function (e) {
        this.chatView.endChat();
    };

    EngagementViewController.prototype.disconnectCancelClicked = function (e) {
        // TODO: What should i do with this?
    };

    EngagementViewController.prototype.updateChatId = function (data) {
        var chatIds = data.newValue ? Object.keys(data.newValue) : [data];
        for (var i = 0; i < chatIds.length; i++) {
            var chatId = chatIds[i];
            if (chatId) {
                if (this.chatId) {
                    if (!this.singleton) {
                        this.chatInput.updateChatId(chatId);
                    }
                    this.chatView.updateChatId(chatId);
                    if (this.slaChargerView) {
                        this.slaChargerView.updateChatId(chatId);
                    }
                    if (this.fileSharingView) {
                        this.fileSharingView.updateChatId(chatId);
                    }
                    if (this.coappInviteView) {
                        this.coappInviteView.updateChatId(chatId);
                    }
                    this.updateTransferView(chatId);
                    this.privateMessageDialog.updateChatId(chatId);
                    this.unformattedTextDialog.updateChatId(chatId);
                    this.takeOverDialog.updateChatId(chatId);
                    this.unbindChatModel();
                    this.resetConversationPresence(this.chatId);
                }
                else {
                    this.addChatView(chatId);
                    if (!this.singleton) {
                        this.addChatInput(chatId);
                    }
                    this.addPrivateMessageDialog(chatId);
                    this.addUnformattedTextDialog({ chatId: chatId, chatsRootModelPath: this.chatsRootModelPath });
                    this.addContentPreviewDialog();
                    this.addTakeOverDialog({ chatId: chatId, chatsRootModelPath: this.chatsRootModelPath });
                    this.updateViewComponents();
                    this.initDialogManager();
                }
                this.chatId = chatId;
                this.updateEngagementViews();
                this.bindChatModel();
                if (this.visible) {
                    this.setDropDownAndShortcuts();
                }
                this.setPresenceStatus(true);
                this.removeLoading();
                this.ensurePartialResolved();
            }
        }
    };

    EngagementViewController.prototype.setOfflineChatId = function (chatId, supportHighLightText) {
        if (!this.chatView) {
            this.addChatView();
        }
        if (this.chatId === chatId) {
            return;
        }
        this.chatId = chatId;
        this.chatView.setOfflineChatView(this.chatId, supportHighLightText);
        this.unformattedTextDialog.updateChatId(chatId);
        this.takeOverDialog.updateChatId(chatId);
        this.updateEngagementStartTime();
        this.updateViewComponents();
        this.updateEngagementViews();
        var visitorName = this.getModelParam(this.chatsRootModelPath + this.chatId + '.visitorInfo.visitorName');
        this.handleParticipantNameUpdated({ newValue: visitorName });
    };

    EngagementViewController.prototype.dispose = function () {
        this.clearPresenceTimer();
        ViewController.prototype.dispose.call(this);
    };

    EngagementViewController.prototype.bindChatModel = function () {
        this.bindModel({
            modelPath: this.chatsRootModelPath + this.chatId + '.visitorInfo.visitorName',
            callback: this.handleParticipantNameUpdated
        });
        this.bindModel({
            modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.startTime',
            callback: this.updateEngagementStartTime
        });
        this.bindModel({
            modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.badges',
            callback: this.updateBadges
        });
        this.bindModel({
            modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.isConversationResolved',
            callback: this.updateConversationResolved
        });
        if (this.singleton) { // table widget mode
            this.bindModel({
                modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.state',
                callback: this.setSingletonSpectateDropdownMenu
            });
        } else {
            if (lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId)) {
                this.bindModel({
                    modelPath: this.chatsRootModelPath + this.chatId + '.agentInfo',
                    callback: this.onAssignedAgentChanged,
                    context: this
                });
                this.bindModel({
                    modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.activeDialogId',
                    callback: this.onActiveDialogIdChanged,
                    context: this,
                    trigger: false // must not trigger the first state, as this handler is responsible for showing a dialog - we don't want that on init});
                });
                if(this.isOnlinePresenceEnabled) {
                    this.bindModel({
                        modelPath: this.chatsRootModelPath + this.chatId + '.visitorInfo.isOnlinePresence',
                        callback: this.setVisitorPresence,
                        context: this
                    });
                }
                //If I'm allowed to participate in others' conversations, and this is a spectated conversation for me
                if ((privilegesController.hasViewAllChatsPrivilege() || privilegesController.hasAgentManagerModulePrivilege()) && lpTag.WebAgent.logicController.isSpectatedEngagementByChatId(this.chatId)) {
                    this.bindModel({
                        modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.allParticipantsHash',
                        callback: this.onLoggedInParticipantRoleChanged,
                        context: this
                    });
                }
            }
        }
    };

    EngagementViewController.prototype.unbindChatModel = function () {
        this.unbindModel({
            modelPath: this.chatsRootModelPath + this.chatId + '.visitorInfo.visitorName',
            callback: this.handleParticipantNameUpdated
        });
        this.unbindModel({
            modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.startTime',
            callback: this.updateEngagementStartTime
        });
        this.unbindModel({
            modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.badges',
            callback: this.updateBadges
        });
        this.unbindModel({
            modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.isConversationResolved',
            callback: this.updateConversationResolved
        });
        if (this.singleton) { // table widget mode
            this.unbindModel({
                modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.state',
                callback: this.setSingletonSpectateDropdownMenu
            });
        } else {
            if (lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId)) {
                this.unbindModel({
                    modelPath: this.chatsRootModelPath + this.chatId + '.agentInfo',
                    callback: this.onAssignedAgentChanged,
                    context: this
                });
                this.unbindModel({
                    modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.activeDialogId',
                    callback: this.onActiveDialogIdChanged,
                    context: this
                });
                if(this.isOnlinePresenceEnabled) {
                    this.unbindModel({
                        modelPath: this.chatsRootModelPath + this.chatId + '.visitorInfo.isOnlinePresence',
                        callback: this.setVisitorPresence,
                        context: this
                    });
                }
                if ((privilegesController.hasViewAllChatsPrivilege() || privilegesController.hasAgentManagerModulePrivilege()) && lpTag.WebAgent.logicController.isSpectatedEngagementByChatId(this.chatId)) {
                    this.unbindModel({
                        modelPath: this.chatsRootModelPath + this.chatId + '.chatInfo.allParticipantsHash',
                        callback: this.onLoggedInParticipantRoleChanged,
                        context: this
                    });
                }
            }
        }
    };

    EngagementViewController.prototype.addChatView = function (chatId) {
        if (!this.disposed) {
            this.chatView = new ChatViewController({
                modelController: this.modelController,
                visitorId: this.visitorId,
                chatId: chatId,
                templateFile: 'LP_chat_view.html',
                singleton: this.singleton,
                chatsRootModelPath: this.chatsRootModelPath,
                bindToChatModel: this.bindToChatModel,
                asyncMessaging: (this.engagementType && this.engagementType === lpTag.WebAgent.logicController.engagementTypes.asyncMessaging)
            });
            this.addViewController({ viewController: this.chatView, target: this.LPViewMap.engagementArea });
        }
    };

    EngagementViewController.prototype.addSlaChangerView = function (chatId) {
        this.slaChargerView = new SlaChangerViewController({
            modelController: this.modelController,
            chatId: chatId
        });
    };

    EngagementViewController.prototype.addFileSharingView = function (visitorId, chatId) {
        this.fileSharingView = new FileSharingViewController({
            modelController: this.modelController,
            visitorId: visitorId,
            chatId: chatId
        });
    };

    EngagementViewController.prototype.addCoAppInviteView = function (chatId, visitorId) {
        if (lpTag.WebAgent.logicController.isEngagementAsyncMessaging(chatId) &&
            (lpTag.WebAgent.logicController.hasCoBrowseFeature('app') ||
                lpTag.WebAgent.logicController.hasLiveVoiceFeature() ||
                lpTag.WebAgent.logicController.hasLiveVideoFeature())) {
            this.coappInviteView = new CoAppInviteViewController({
                modelController: this.modelController,
                chatId: chatId,
                visitorId: visitorId
            });
        }
    };

    EngagementViewController.prototype.addIDandVView = function (chatId) {
        if (!lpTag.WebAgent.logicController.isEngagementAsyncMessaging(chatId) && lpTag.WebAgent.logicController.hasIdnv()) { //todo- and real time
            this.IDandVView = new IdnvViewController({
                modelController: this.modelController,
                chatId: chatId,
                visitorId: this.visitorId
            });
        }
    };

    EngagementViewController.prototype.addChatInput = function (chatId) {
        if (lpTag.WebAgent.logicController.isEngagementAsyncMessaging(chatId) && privilegesController.hasSetManualSlaPrivilege()) {
            this.addSlaChangerView(chatId);
        }
        if (lpTag.WebAgent.logicController.canSendFileFromLocalFileSystem(chatId)) {
            this.addFileSharingView(this.visitorId, chatId);
        }
        this.addIDandVView(chatId);
        this.addCoAppInviteView(chatId, this.visitorId);
        var ChatInputState = 'rich_text_chat_input';
        var clipboardNotificationHandler = (lpTag.WebAgent.logicController.isAgentAlertOnPasteEnabled() ? this.clipboardNotificationHandler.bind(this) : null);

        this.addClass(this.LPViewMap.engagementState, ChatInputState);

        this.chatInput = new RichTextChatInputViewController({
            modelController: this.modelController,
            chatId: chatId,
            onResize: this.chatInputResize.bind(this),
            visitorId: this.visitorId,
            templateFile: 'LP_chat_input.html',
            parent: this,
            customMenuItems: [{ viewController: this.slaChargerView }, { viewController: this.IDandVView }, { viewController: this.coappInviteView }, {viewController: this.fileSharingView}],
            clipboardNotificationHandler: clipboardNotificationHandler
        });
        this.addViewController({ viewController: this.chatInput, target: '.lpview_engagement_area' });
    };
    EngagementViewController.prototype.clipboardNotificationHandler = function () {
        this.showDialog({
            title: this.translate('agentDialogsNotifications.PasteToEditorNotification.title'),
            description: this.translate('agentDialogsNotifications.PasteToEditorNotification.description'),
            okButton: this.translate('confirm'),
            okCallback: (function () {
                this.chatInput.lpFocus(); //Bring back focus to the chat input.
            }).bind(this),
            targetView: window.MainViewControllerBody,
            xEnabled: true,
            modal: true
        });
    };

    EngagementViewController.prototype.addTransferView = function (chatId) {
        if (!this.transferView) {
            this.transferView = new TransferViewController({
                modelController: this.modelController,
                chatId: chatId,
                visitorId: this.visitorId,
                templateFile: 'LP_transfer_engagement.html',
                hidden: true
            });
            this.addViewController({ viewController: this.transferView, target: this.LPViewMap.transferPlaceholder });
        }
    };

    EngagementViewController.prototype.addPrivateMessageDialog = function (chatId) {
        this.privateMessageDialog = new PrivateMessageDialogViewController({
            chatId: chatId,
            modelController: this.modelController,
            templateFile: 'LP_private_message_dialog.html',
            hidden: true
        });
        this.addViewController({
            viewController: this.privateMessageDialog,
            target: this.LPViewMap.privateMessagePlaceholder
        });
    };

    EngagementViewController.prototype.handleParticipantNameUpdated = function (data) {
        // Handle visitor name, if none defined use a custom one, otherwise use what the the user defined.
        var visitorName = data.newValue === 'visitor' ? this.translate('participantDefaultName') : data.newValue;
        this.setVisitorName(visitorName);
    };

    EngagementViewController.prototype.handleParticipantAvatarUpdated = function (data) {
        if (data.newValue || data.newValue === '') {
            this.avatar.showAvatar(this.visitorId);
        }
    };

    EngagementViewController.prototype.setVisitorName = function (visitorName) {
        if (visitorName) {
            this.visitorName = visitorName;
            lpUtils.setElementText(this.getFirstElement(this.LPViewMap.visitorName), visitorName);
        }
    };

    EngagementViewController.prototype.handleEngagementStateChanged = function (data) {
        //handle shortcuts for split session instances
        var state = data && data.newValue ? data.newValue : data;
        this.setEngagementState(state);
    };

    EngagementViewController.prototype.setEngagementActive = function () {
        this.activeEngagement = true;
        this.dismissDialog();
        var engagementState = this.getFirstElement(this.LPViewMap.engagementState);
        this.removeClass(engagementState, this.engagementStates.inactive.cssClass);
        this.addClass(engagementState, this.engagementStates.active.cssClass);
        this.setChatInputEngagementActive();

        var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath);
        if (lpTag.WebAgent.logicController.isAcceptedEngagement(this.visitorId) || lpTag.WebAgent.logicController.isLoggedInAgentManagerParticipant(this.chatId, activeDialogId, this.chatsRootModelPath)) {
            this.hidePrivateMessageDialog();
        }

        engagementState = null;
    };

    EngagementViewController.prototype.setEngagementInactiveCompleted = function () {
        this.activeEngagement = false;
        this.dismissDialog();
        this.setChatInputEngagementInactiveCompleted();
        var engagementState = this.getFirstElement(this.LPViewMap.engagementState);
        this.removeClass(engagementState, this.engagementStates.active.cssClass);
        this.addClass(engagementState, this.engagementStates.inactive.cssClass);
        this.transferDisposed();
        engagementState = null;
    };

    EngagementViewController.prototype.isConnectionActive = function () {
        var active;
        if (this.chatId && lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId)) {
            active = lpTag.WebAgent.logicController.isAmsConnectionStatusActive();
        } else { // todo - check for isEngagementRealTimeChat - this means this.chatId should always be available here (and not undefined)
            active = lpTag.WebAgent.logicController.isConnectionStatusActive();
        }
        return !!active;
    };

    EngagementViewController.prototype.onAssignedAgentChanged = function (data) {
        // this listener must be bound to any participation flow (accepted/spectated) and delegate to a specific flow when called,
        // as the assigned-agent state may change during the engagement lifecycle


        var agentAdded = data.newValue && !data.oldValue,
            agentRemoved = data.removedValue,
            agentReplaced = isAgentReplaced(), //takeover flow
            // check if there is another agent (suggested) - transfer to agent flow
            otherAgentSuggested = lpTag.WebAgent.logicController.getSuggestedAgentInfoInConversation(this.chatId, this.chatsRootModelPath);

        // Don't handle updates, only additions and removals.
        // Ignore side-effects of setting the agent-typing indication in the chat.agentInfo model path
        if (ignoreThisEventBecauseItsOnlyTyping()) {
            return;
        }

        this.setDropDownAndShortcuts();

        var dialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath);
        var role = lpTag.WebAgent.logicController.getLoggedInAgentRoleInConversationDialog(this.chatId, dialogId, this.chatsRootModelPath);
        var amIActiveParticipantInConversation = (role === this.participantRoles.READER) || (role === this.participantRoles.MANAGER);

        // removed agent indicates the conversation was unassigned (returned to queue) or transferred to another agent
        if (agentRemoved && !amIActiveParticipantInConversation) {
            if (this.loggedInAgentIssuedReturnToQueueCommand || !this.visible) {
                this.hideUnJoinedEngagement();
            } else {
                if (otherAgentSuggested) {
                    this.raiseNotification({
                        title: this.translate('transferToAgentConversationNotificationTitle'),
                        message: this.translateObj('transferToAgentConversationNotificationMessage', [{ key: this.visitorName }, { key: otherAgentSuggested.agentName }]),
                        dialogOkCallback: this.hideUnJoinedEngagement
                    });
                } else {
                    this.raiseNotification({
                        title: this.translate('conversationReturnedToQueueByManagerNotificationTitle'),
                        message: this.translateObj('conversationReturnedToQueueByManagerNotificationText', [{ key: this.visitorName }]),
                        dialogOkCallback: this.hideUnJoinedEngagement
                    });
                }
            }
            // on unassign always reset the flag, regardless of participation type (accepted/spectated)
            this.loggedInAgentIssuedReturnToQueueCommand = false;
        }

        if (agentReplaced && !amIActiveParticipantInConversation) {
            var loggedInMessagingAgent = lpTag.WebAgent.logicController.getModelParam('agent.messagingUserId');
            if (loggedInMessagingAgent === data.oldValue.messagingUserId) {
                if (this.visible) {
                    this.raiseNotification({
                        title: this.translate('takeoverConversationNotificationTitle'),
                        message: this.translateObj("takeoverConversationNotificationMessage", [{ key: this.visitorName }, { key: data.newValue.agentName }]),
                        dialogOkCallback: this.hideUnJoinedEngagement
                    });
                }
                else {
                    this.hideUnJoinedEngagement();
                }
            }
        }

        function ignoreThisEventBecauseItsOnlyTyping() {
            if (!agentAdded && !agentRemoved && !agentReplaced) {
                return true;
            }
            if ((agentAdded && !agentAdded.messagingUserId) && (agentRemoved && !agentRemoved.messagingUserId)) {
                return true;
            }
            if (agentRemoved && _.contains(agentRemoved, agentRemoved.agentTyping) && _.size(agentRemoved) === 1) {
                return true;
            }
            if (agentAdded && _.contains(agentAdded, agentAdded.agentTyping) && _.size(agentAdded) === 1) {
                return true;
            }
            return false;
        }

        function isAgentReplaced() {
            return !!(data.newValue && data.newValue.messagingUserId) &&
                (data.oldValue && data.oldValue.messagingUserId) &&
                (data.newValue.messagingUserId !== data.oldValue.messagingUserId);
        }
    };

    EngagementViewController.prototype.hideUnJoinedEngagement = function () {
        var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath);
        var isJoinedAsManager = lpTag.WebAgent.logicController.isLoggedInAgentManagerParticipant(this.chatId, activeDialogId, this.chatsRootModelPath);
        if (isJoinedAsManager) {
            // leave the engagement open if it's opened by a joined manager (i.e. the logged-in agent is a manager
            // participant in the current conversation)
            return;
        }

        this.hideEngagement();
    };

    EngagementViewController.prototype.onActiveDialogIdChanged = function (data) {
        // TODO: unified with the chat state event.
        data = data || {};

        var mainDialog = lpTag.WebAgent.logicController.getMainDialogOfConversation(this.chatId, this.chatsRootModelPath);

        if (data.oldValue && mainDialog && mainDialog.dialogId === data.oldValue) { // main dialog has been closed
            var closedBy = this.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo.dialogs.' + mainDialog.dialogId + '.closedBy');
            var isClosedByAgent = (closedBy === lpTag.WebAgent.logicController.conversationCloseReasons.AGENT);

            if (isClosedByAgent && !this.loggedInAgentIssuedCloseCommand) {
                this.raiseNotification({
                    title: this.translate('conversationClosedByManagerNotificationTitle'),
                    message: this.translateObj('conversationClosedByManagerNotificationText', [{ key: this.visitorName }])
                });
            }
            this.setPresenceStatus(false);

            // on closed chats, always reset the flag, regardless of the originator (agent/consumer)
            this.loggedInAgentIssuedCloseCommand = false;
        }
    };

    EngagementViewController.prototype.setVisitorPresence = function () {
        var conversationId = this.chatId || lpTag.WebAgent.logicController.getConversationIdFromVisitorId(this.visitorId);
        var lastPresenceTime = this.getModelParam(this.chatsRootModelPath + conversationId + '.visitorInfo.lastPresenceTime');
        var isOnline = this.getModelParam(this.chatsRootModelPath + conversationId + '.visitorInfo.isOnlinePresence');

        setOnlinePresenceClass.call(this);
        var text = getPresenceText.call(this);
        lpUtils.setElementText(this.getFirstElement(this.LPViewMap.visitorPresence), text);


        function setOnlinePresenceClass() {
            var engagementHeader = this.getFirstElement(this.LPViewMap.engagementHeader);
            if (isOnline) {
                this.addClass(engagementHeader, this.LPClassesMap.onlinePresence);
            }
            else {
                this.removeClass(engagementHeader, this.LPClassesMap.onlinePresence);
            }
        }

        function getPresenceText() {
            var lastVisitorLine;
            //backup case - take time from last visitor line
            if (!lastPresenceTime) {
                if (!this.lastPresence) {
                    lastVisitorLine = this.getLastVisitorLine(conversationId);
                    lastPresenceTime = lastVisitorLine ? lastVisitorLine.time : null;
                    this.lastPresence = lastPresenceTime;
                }
                else {
                    lastPresenceTime = this.lastPresence;
                }

                if (!lastPresenceTime) {
                    this.bindPresenceEvents(conversationId);
                    return '';
                }
            }

            this.unbindPresenceEvents(conversationId);
            var key = 'presence_';
            var value = '';
            var lastPresenceDate = new Date(lastPresenceTime);
            var TodayStart = getStartTimeOfDate(new Date()); //today at 12:00AM
            var yesterdayStart = TodayStart - 86400000; //yesterday at 12:00AM

            if (isOnline) { //online case
                key += 'online';
            }
            else if (lastPresenceTime - TodayStart > 0) { //today case
                key += 'today';
                value = getHoursAndMinutesFormat(lastPresenceDate);
            }
            else if (lastPresenceTime - yesterdayStart > 0) { //yesterday case
                key += 'yesterday';
                value = getHoursAndMinutesFormat(lastPresenceDate);
            }
            else { //older case
                key += 'old';
                value = getFullDateFormat(lastPresenceDate);
            }
            return this.translateObj(key, [{ key: value }]);


            function getStartTimeOfDate(date) {
                var startDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
                return new Date(startDate).getTime();
            }

            // the func get's date and return time in hh:mm format
            function getHoursAndMinutesFormat(date) {
                var hours = '0' + date.getHours();
                var minutes = '0' + date.getMinutes();
                return hours.substr(-2) + ':' + minutes.substr(-2);
            }

            // the func get's date and return time in dd/mm/yyyy format
            function getFullDateFormat(date) {
                var day = '0' + date.getDate();
                var month = '0' + (date.getMonth() + 1);
                var year = date.getFullYear();
                return day.substr(-2) + '/' + month.substr(-2) + '/' + year;
            }
        }
    };

    EngagementViewController.prototype.bindPresenceEvents = function (conversationId) {
        if (!this.bindToLines) {
            this.bindToLines = true;
            this.addClass(this.getFirstElement(this.LPViewMap.visitorName), this.LPClassesMap.noPresenceStatus);
            this.bindModel({
                modelPath: this.chatsRootModelPath + conversationId + '.oldChatLine.lines',
                callback: this.setVisitorPresence,
                context: this
            });
        }
    };

    EngagementViewController.prototype.unbindPresenceEvents = function (conversationId) {
        if (this.bindToLines) {
            this.bindToLines = false;
            this.removeClass(this.getFirstElement(this.LPViewMap.visitorName), this.LPClassesMap.noPresenceStatus);
            this.unbindModel({
                modelPath: this.chatsRootModelPath + conversationId + '.oldChatLine.lines',
                callback: this.setVisitorPresence,
                context: this
            });
        }
    };

    EngagementViewController.prototype.resetConversationPresence = function (conversationId) {
        delete this.lastPresence;
        this.unbindPresenceEvents(conversationId);
    };

    EngagementViewController.prototype.getLastVisitorLine = function (conversationId) {
        var linesType = ['newChatLine.lines', 'oldChatLine.lines'];
        var visitorId = this.getModelParam(this.chatsRootModelPath + conversationId + '.visitorInfo.visitorId');

        for (var j = 0; j < linesType.length; j++) {
            var linesArray = this.getModelParam(this.chatsRootModelPath + conversationId + '.' + linesType[j]); //new or old chat lines
            if (linesArray) {
                for (var i = linesArray.length - 1; i >= 0; i--) { //start from the last line
                    if (linesArray[i].originatorId === visitorId) {
                        return linesArray[i];
                    }
                }
            }
        }
    };

    EngagementViewController.prototype.setPresenceStatus = function (enable) {
        if (this.isOnlinePresenceEnabled && !this.singleton) {
            this.clearPresenceTimer();
            var engagementHeader = this.getFirstElement(this.LPViewMap.engagementHeader);
            var conversationId = this.chatId || lpTag.WebAgent.logicController.getConversationIdFromVisitorId(this.visitorId);
            var mainDialog = lpTag.WebAgent.logicController.getMainDialogOfConversation(conversationId, this.chatsRootModelPath);
            if(enable && mainDialog && mainDialog.state === lpTag.WebAgent.logicController.conversationStates.OPEN) {
                this.addClass(engagementHeader, this.LPClassesMap.onlinePresenceEnabled);
                this.setVisitorPresence();
                this.presenceTimer = setInterval(this.setVisitorPresence.bind(this), 60000); //update presence every 60 seconds
            }
            else {
                this.removeClass(engagementHeader, this.LPClassesMap.onlinePresenceEnabled);
            }
        }
    };

    EngagementViewController.prototype.clearPresenceTimer = function () {
        if (this.presenceTimer) {
            clearInterval(this.presenceTimer);
        }
    };

    EngagementViewController.prototype.raiseNotification = function (options) {
        options = options || {};
        // only show dialog if engagement is focused
        if (this.visible) {
            this.showDialog({
                title: options.title,
                description: options.message,
                okButton: this.translate('ok'),
                okCallback: options.dialogOkCallback,
                targetView: window.MainViewControllerBody,
                xEnabled: false,
                modal: true
            });
        }
    };

    EngagementViewController.prototype.onLoggedInParticipantRoleChanged = function () {
        var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath);
        if (activeDialogId) {
            var role = lpTag.WebAgent.logicController.getLoggedInAgentRoleInConversationDialog(this.chatId, activeDialogId, this.chatsRootModelPath);
            var isReader = role === this.participantRoles.READER;
            var isManager = role === this.participantRoles.MANAGER;

            this.setDropDownAndShortcuts();

            this.toggleClass(this.LPViewMap.engagementHeader, this.LPClassesMap.manager, isManager);
            this.toggleClass(this.LPViewMap.engagementHeader, this.LPClassesMap.reader, isReader);
        }
    };

    EngagementViewController.prototype.setChatInputEngagementActive = function () {
        if (this.chatInput && this.chatInput.setEngagementActive) {
            this.chatInput.setEngagementActive();
        }
    };

    EngagementViewController.prototype.setChatInputEngagementInactiveCompleted = function () {
        if (this.chatInput && this.chatInput.setEngagementInactiveCompleted) {
            this.chatInput.setEngagementInactiveCompleted();
        }
    };

    EngagementViewController.prototype.addContentPreviewDialog = function (options) {
        if (!this.contentPreviewDialog) {
            this.contentPreviewDialog = new ContentPreviewDialogViewController({
                modelController: this.modelController,
                templateFile: 'LP_content_preview_dialog.html',
                hidden: true
            });
            this.addViewController({
                viewController: this.contentPreviewDialog,
                target: this.LPViewMap.contentPreviewPlaceHolder
            });
        }
    };

    EngagementViewController.prototype.handleMessageFromWidget = function(data) {
        if (!(data && data.newValue && data.newValue.eventData && (data.newValue.eventData.json || data.newValue.eventData.text))) {
            return;
        }

        var error;
        var evData = data.newValue.eventData;
        var doneCallback = evData.doneCallback || $.noop;

        // validations
        var isMyChat = lpTag.WebAgent.logicController.isMyChat(this.chatId);
        var isMessaging = lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId, this.chatsRootModelPath);
        var dialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId);
        var in_survey_badge = this.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo.badges.in_survey');
        if((isMessaging && lpTag.WebAgent.logicController.isLoggedInAgentReaderParticipant(this.chatId, dialogId)) || // haven't joined messaging conversation
            (!isMessaging && !isMyChat && !this.chatInput.hasJoinedConversation())) { // haven't clicked the 'Join Conversation' button in (chat only, UI only)
            if (in_survey_badge) {
                error = {
                    msg: this.translate('survey_in_progress_error_content_message'),
                    obj: new Error('current conversation has ended and the survey is in progress')
                };
            } else {
                error = {
                    msg: this.translate('content_preview_not_participant_error'),
                    obj: new Error('current agent is not an active participant of the conversation')
                };
            }
        }

        // quick replies only valid for messaging
        if (!error && evData.quickReplies && !lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId)) {
            error = {
                msg: this.translate('quick_replies_not_supported_for_live_chat'),
                obj: new Error('quick replies is not supported for live chat')
            };
        }

        // macro replacements
        if (isMessaging) { // todo is this correct? just for messaging?
            this.executeMacroReplacements(evData);
        }

        if(error) {
            if (error.msg) {
                this._showErrorDialog(this.translate('content_preview_error_title'), error.msg);
            }
            this.logger.debug('failed to render content preview', error.obj);
            doneCallback(error.obj);
        } else if (evData.text) {
            this.handleTextFromWidget(evData.text, evData.quickReplies, doneCallback);
        } else {
            this.handleStructuredContentFromWidget(evData.json, evData.metadata, evData.quickReplies, doneCallback);
        }

    };

    EngagementViewController.prototype.executeMacroReplacements = function(data) {
        var context;

        function executeMacroText(text) {
            var postMacro = text;
            if (PredefinedContentMacroUtils.test(text)) {
                context = context || lpTag.WebAgent.logicController.getPredefinedContentMacroContext(this.chatId);
                postMacro = PredefinedContentMacroUtils.replace(text, context);
            }
            return postMacro;
        }

        function executeMacroJson(json) {
            var isString, jsonStr, jsonStrPostMacro;
            try {
                isString = _.isString(json);
                jsonStr = isString ? json : JSON.stringify(json);
                jsonStr = executeMacroText.call(this, jsonStr);
                jsonStrPostMacro = isString ? jsonStr : JSON.parse(jsonStr);
                return jsonStrPostMacro;
            }
            catch (e) {
                this.logger.error('failed json parsing for PDC macro replacements in chat: ' + this.chatId + ': ', json);
                return json;
            }
        }

        // text
        if (data.text) {
            data.text = executeMacroText.call(this, data.text);
        }
        // structured content
        else if (data.json) {
            data.json = executeMacroJson.call(this, data.json);
        }
        // quick replies
        if (data.quickReplies) {
            data.quickReplies = executeMacroJson.call(this, data.quickReplies);
        }
    };

    EngagementViewController.prototype.handleTextFromWidget = function(text, quickReplies, doneCallback) {
        var quickRepliesObj, error;

        try {
            quickRepliesObj = !_.isEmpty(quickReplies) && _.isString(quickReplies) ? JSON.parse(quickReplies) : quickReplies;
        } catch (ex) {
            error = {
                msg: this.translate('content_preview_error_msg'),
                obj: ex
            };
        }

        // basic validation for quick replies
        if (!error && quickRepliesObj) {

            try {
                SchemaValidator.validate(SchemaValidator.KEYS.QUICK_REPLIES, quickRepliesObj);
            } catch (ex) {
                error = {
                    msg: this.translate('content_preview_error_msg'),
                    obj: new Error('quick replies json is invalid')
                };
            }
        }

        if(error) {
            if (error.msg) {
                this._showErrorDialog(this.translate('content_preview_error_title'), error.msg);
            }
            this.logger.debug('failed to render text content preview', error);
            doneCallback(error);
        }
        else {
            if (quickRepliesObj) {
                this.contentPreviewDialog.setContent({text: text, quickReplies: quickRepliesObj});
                this.contentPreviewDialog.onSend(this.sendLine.bind(this, {
                    textType: "text/plain",
                    text: text,
                    quickReplies: quickRepliesObj
                }, doneCallback));
                this.DialogManager.showDialog('contentPreview');
            }
            else {
                // pre-defined content flow
                if (this.getModelParam('chats.' + this.chatId + '.chatInfo.state') === lpTag.WebAgent.logicController.chatStates.ended) {
                    // this is for backward compatibility with widget sdk
                    doneCallback('Chat line not sent. Reason: the chat has already ended.');
                } else {
                    this.chatInput.addPreDefinedContent({newValue: {eventData: {text: text}}});
                    doneCallback();
                }
            }
        }
    };

    EngagementViewController.prototype.handleStructuredContentFromWidget = function(json, metadata, quickReplies, doneCallback) {
        var jsonObj, metadataArr, quickRepliesObj, scRenderResult, error;
        var MESSAGE_LENGTH_LIMIT = 15000;

        // validate sc json string length
        var jsonStr = _.isString(json) ? json : JSON.stringify(json);
        if (jsonStr.length > MESSAGE_LENGTH_LIMIT) {
            error = {
                msg: this.translateObj('structured_content_length_limit_error', [MESSAGE_LENGTH_LIMIT]),
                obj: new Error('the message exceeds the limitation of ' + MESSAGE_LENGTH_LIMIT + ' characters')
            };
        }

        if (!error) {
            // transform the strings to objects
            try {
                jsonObj = !_.isEmpty(json) && _.isString(json) ? JSON.parse(json) : json;
                metadataArr = !_.isEmpty(metadata) && _.isString(metadata) ? JSON.parse(metadata) : metadata;
                quickRepliesObj = !_.isEmpty(quickReplies) && _.isString(quickReplies) ? JSON.parse(quickReplies) : quickReplies;
            } catch (ex) {
                error = {
                    obj: ex
                };
            }
        }

        if(!error) {
            // Notice:  this should be only a 'validate' stage but in json-pollok this is not supported and
            //          the validation is bundled with the rendering. When this will change then the validation
            //          validation should be done here and the rendering should be done inside the content-preview-dialog0view-controller
            scRenderResult = StructuredContentManager.render(jsonObj);
            if(scRenderResult.error) {
                error = {
                    msg: this.translate('content_preview_error_msg'),
                    obj: scRenderResult.error
                };
            }
        }

        // basic validation for quick replies
        if (!error && quickRepliesObj) {
            try {
                SchemaValidator.validate(SchemaValidator.KEYS.QUICK_REPLIES, quickRepliesObj);
            } catch (ex) {
                error = {
                    msg: this.translate('content_preview_error_msg'),
                    obj: new Error('quick replies json is invalid')
                };
            }
        }

        if (error) {
            if (error.msg) {
                this._showErrorDialog(this.translate('content_preview_error_title'), error.msg);
            }
            this.logger.debug('failed to render content preview', error.obj);
            doneCallback(error.obj);
        }
        else {
            this.contentPreviewDialog.setContent({ scRenderResult: scRenderResult.domEL, quickReplies: quickRepliesObj });
            this.contentPreviewDialog.onSend(this.sendLine.bind(this, {
                type: "richContent",
                textType: "rich-content",
                json: jsonObj,
                quickReplies: quickRepliesObj,
                metadata: metadataArr
            }, doneCallback));
            this.DialogManager.showDialog('contentPreview');
        }
    };

    EngagementViewController.prototype.sendLine = function(data, doneCallback) {
        doneCallback = doneCallback || $.noop;

        function _resumeConversationWithLine() {
            var campaignInfo;

            var originContext = this.getModelParam('chats.' + this.chatId + '.chatInfo.originContext');
            var skillId = this.getModelParam('chats.' + this.chatId + '.chatInfo.skillIds');
            var retryCallback = _resumeConversationWithLine.bind(this);

            // Adding the Campaign information if has any.
            var engagementId = this.getModelParam('chats.' + this.chatId + '.chatInfo.engagementId');
            var campaignId   = this.getModelParam('chats.' + this.chatId + '.chatInfo.campaignId');

            if(engagementId && campaignId){
                campaignInfo = {
                    engagementId: engagementId,
                    campaignId: campaignId
                };
            }

            var chatLineObj = lpUtils.mergeObjects({
                chatId: this.chatId,
                sendingAgentName: this.getModelParam('agent.agentName')
            }, data);

            // createConversation flow expects text to by on textValue key
            chatLineObj.textValue = chatLineObj.text;
            this.modelController.createConversation({
                conversationId: this.chatId,
                originContext: originContext,
                consumerId: this.visitorId,
                skillId: skillId || '-1',
                campaignInfo: campaignInfo,
                agentName: this.chatInput && this.chatInput.agentName,
                cannedResponse: this.chatInput && this.chatInput.cannedResponse,
                error: function (errorData) {
                    this.onResumeError(errorData, retryCallback);
                },
                newChatLine: chatLineObj,
                context: this.chatInput
            });
        }

        if (this.getModelParam('chats.' + this.chatId + '.chatInfo.state') === lpTag.WebAgent.logicController.chatStates.ended) {
            if (this.chatInput.isOnResumeState()) {
                _resumeConversationWithLine.call(this);
            } else {
                this._showErrorDialog(this.translate('content_preview_error_title'), this.translate('content_preview_conv_close_error'));
                this.logger.debug('fail to render content from widget', 'Content not sent. Reason: the chat has already ended.');
                doneCallback('Content not sent. Reason: the chat has already ended.');
            }

        } else {
            var chatLineObj = lpUtils.mergeObjects({
                chatId: this.chatId,
                source: 'agent',
                by: this.getModelParam('agent.agentName'),
                time: new Date()
            }, data);
            this.modelController.addLine(chatLineObj);
        }
    };

    EngagementViewController.prototype._showErrorDialog = function (title, errorMessage) {
        this.logger.debug(title + ' ' + errorMessage);
        this.showDialog({
            title: title,
            description: errorMessage,
            cancelButton: this.translate('close'),
            targetView: window.MainViewControllerBody,
            modal: true
        });
    };

// --------- Dropdown operations ------------------------------------------------------

// Messaging 1 - Minimize engagement
    EngagementViewController.prototype.hideEngagement = function () {
        var dialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath);
        var role = lpTag.WebAgent.logicController.getLoggedInAgentRoleInConversationDialog(this.chatId, dialogId, this.chatsRootModelPath);

        if (role && role !== this.participantRoles.READER) {
            this.modelController.setAgentTyping({
                chatId: this.chatId,
                typing: false
            });
        }
        lpTag.WebAgent.logicController.disposeParticipant(this.visitorId);
        this.viewEventsHandler.fireEvent({
            appName: this.visitorId,
            UIEvent: this.eventType.VISITOR_DISPOSED,
            eventData: { visitorId: this.visitorId },
            deleteOnFire: true
        });
    };
// Messaging 2 - Return to queue
    EngagementViewController.prototype.returnToQueue = function () {
        var unassignRequest, assignedAgentId;

        assignedAgentId = this.getAssignedAgentMessagingUserId();
        // conversations in queue don't have an assigned agent, so no use in unassigning them (results in an error)
        if (assignedAgentId) {
            this.modelController.setAgentTyping({
                chatId: this.chatId,
                typing: false
            });
            unassignRequest = {
                userId: assignedAgentId,
                conversationId: this.chatId,
                dialogId: lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath),
                success: successCallback,
                error: errorCallback,
                context: this
            };
            this.modelController.unassignConversation(unassignRequest);
        }
        // setting flag for further handling on assigned-agent events trigger
        this.loggedInAgentIssuedReturnToQueueCommand = true;

        function errorCallback(error) {
            this.logger.error('Return to queue encountered an error for conversation ' + this.chatId);
            this.logger.graph({ name: 'returnToQueueError' });
        }

        function successCallback() {
            this.logger.info('Return to queue ended successfully for conversation ' + this.chatId);
        }
    };

// Messaging 3 - close conversation
    EngagementViewController.prototype.closeConversation = function () {
        var dialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath);
        var hasMessagingMultiDialogSupport = this.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo.newUmsApiActive');
        if (hasMessagingMultiDialogSupport) {
            this.modelController.closeDialog({
                conversationId: this.chatId,
                dialogId: dialogId,
                success: successCallback.bind(this, dialogId, hasMessagingMultiDialogSupport),
                error: errorCallback.bind(this, dialogId, hasMessagingMultiDialogSupport),
                context: this
            });
        } else {
            this.modelController.closeConversation({
                conversationId: this.chatId,
                success: successCallback,
                error: errorCallback,
                context: this
            });
        }

        if (dialogId === lpTag.WebAgent.logicController.getMainDialogOfConversation(this.chatId, this.chatsRootModelPath).dialogId) {
            // setting flag for further handling on conversation-state events trigger
            this.loggedInAgentIssuedCloseCommand = true;
        }

        function errorCallback(dialogId, hasMessagingMultiDialogSupport) {
            if (hasMessagingMultiDialogSupport) {
                this.logger.error('Close dialog of conversation encountered an error for dialog ' + dialogId + ', of conversation ' + this.chatId);
                this.logger.graph({ name: 'closeDialogError' });
            } else {
                this.logger.error('Close conversation encountered an error for conversation ' + this.chatId);
                this.logger.graph({ name: 'closeConversationError' });
            }
        }

        function successCallback(dialogId, hasMessagingMultiDialogSupport) {
            if (hasMessagingMultiDialogSupport) {
                this.logger.info('Close dialog ended successfully for dialog ' + dialogId + ', of conversation ' + this.chatId);
            } else {
                this.logger.info('Close conversation ended successfully for conversation ' + this.chatId);
            }
        }
    };

    EngagementViewController.prototype.leaveConversation = function () {
        var success = function () {
            this.hideEngagement();
            this.logger.info('Leave conversation ended successfully for conversation ' + this.chatId);
        };
        var error = function () {
            this.logger.error('Leave conversation encountered an error for conversation ' + this.chatId);
            this.logger.graph({ name: 'leaveConversationError' });
        };
        this.modelController.removeManagerParticipant({
            conversationId: this.chatId,
            dialogId: lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath),
            success: success,
            error: error,
            context: this
        });
    };

// --------- Other hotkeys operations ---------------------------------------------

// Messaging - My Connections list
    EngagementViewController.prototype.focusTables = function () {
        this.viewEventsHandler.fireEvent({
            appName: TabsManagerViewController.applicationType,
            UIEvent: this.eventType.VISITOR_FOCUSED
        });
    };

// ----------------------------------------------------------------------------------

    EngagementViewController.prototype.lpBlur = function () {
        if (this.visible) {
            if (this.dialogViewController) {
                this.dismissDialog();
            }
            this.clearPresenceTimer();
            this.setDropDownAndShortcuts(true);
            this.lpHide();
            this.chatInput.onBlur();
        }
    };

    EngagementViewController.prototype.lpFocus = function () {
        this.setDropDownAndShortcuts();
        this.lpShow();
        agentLEManager.setLEValue('webAgent.focusedComponent', 'Engagement:' + lpTag.WebAgent.logicController.getEngagementTypeByVisitorId(this.visitorId));
        this.setPresenceStatus(true);
    };

    EngagementViewController.prototype.getAssignedAgentMessagingUserId = function () {
        return this.getModelParam(this.chatsRootModelPath + this.chatId + '.agentInfo.messagingUserId');
    };

    EngagementViewController.prototype.statusChanged = function (data) {
        if (data.newValue !== 'loggedIn' && typeof data.newValue !== 'undefined') {
            this.dispose();
        }
    };

    EngagementViewController.prototype.updateEngagementStartTime = function () {
        if (this.singleton || !this.engagementStartTime || lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId)) {//support in split session only on engagement area, NOT on VF spectate. support on AsyncMessaging
            this.engagementStartTime = this.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo.startTime');
            this.getFirstElement(this.LPViewMap.engagementTime).innerHTML = lpUtils.formatDateAsShortTime(this.engagementStartTime);
        }
    };

    EngagementViewController.prototype.showIconContiner = function (className) {
        var continer = this.getFirstElement('.' + className);
        this.addClass(continer, 'active');
    };

    EngagementViewController.prototype.hideIconContiner = function (className) {
        var continer = this.getFirstElement('.' + className);
        this.removeClass(continer, ['active']);
    };

    EngagementViewController.prototype.updateEngagementSentiment = function (data) {
        if (typeof data.newValue !== "undefined") {
            // remove all old class
            this.removeClass(this.LPViewMap.engagementSentiment, [this.LPClassesMap.negative, this.LPClassesMap.neutral, this.LPClassesMap.positive]);
            var sentimentTag = lpTag.WebAgent.logicController.getSentimentTag(data.newValue);
            this.addClass(this.LPViewMap.engagementSentiment, this.LPClassesMap[sentimentTag]);
            this.getFirstElement(this.LPViewMap.engagementSentiment).title = this.translate('engagement_sentiment_tooltip_' + sentimentTag);

            if (data.newValue === 0) {
                this.hideIconContiner('sentiment_continer');
            } else {
                this.showIconContiner('sentiment_continer');
            }
        }
    };

    EngagementViewController.prototype.updateBadges = function (data) {
        //go over the list of badges to update
        for (var badgeName in data.newValue) {
            if (data.newValue.hasOwnProperty(badgeName)) {
                //make sure the class name is camel cased
                var camelCased = this.replaceWithCamelCase(badgeName);
                //get the container for that badge
                var container = this.getFirstElement(this.LPViewMap[camelCased + "Container"]);
                //get the conversation state
                var state = this.modelController.getModelParam('chats.' + this.chatId + '.chatInfo.messagingState');
                //if that badge is truth-y and the conversation is active add it and otherwise remove it
                if (data.newValue[badgeName] && state === lpTag.WebAgent.logicController.conversationStates.OPEN) {
                    this.addClass(container, "active");
                } else {
                    this.removeClass(container, "active");
                }
            }
        }
        this.setDropDownAndShortcuts();
    };

    EngagementViewController.prototype.updateConversationResolved = function (data) {
        if (typeof data.newValue !== "undefined") {
            var icon = this.getFirstElement(this.LPViewMap.resolved);
            var container = this.getFirstElement(this.LPViewMap.resolvedContainer);
            if (container && icon) {
                if (data.newValue === true) {
                    this.addClass(icon, this.LPClassesMap.true);
                } else {
                    this.addClass(icon, this.LPClassesMap.false);
                }
                icon.title = this.translate('isConversationResolvedTooltip_' + data.newValue);
                this.addClass(container, this.LPClassesMap.active);
            }
        }
    };

    EngagementViewController.prototype.replaceWithCamelCase = function (s) {
        return s.replace(/(_\w)/g, function (m) {
            return m[1].toUpperCase();
        });
    };

    EngagementViewController.prototype.updateDevice = function (data) {
        if (typeof data.newValue !== "undefined") {
            // remove all old class
            this.removeClass(this.LPViewMap.device, [this.LPClassesMap.devicePrefix + this.LPClassesMap.desktop, this.LPClassesMap.devicePrefix + this.LPClassesMap.tablet, this.LPClassesMap.devicePrefix + this.LPClassesMap.mobile]);
            var device = data.newValue;
            this.addClass(this.LPViewMap.device, this.LPClassesMap.devicePrefix + this.LPClassesMap[device.toLowerCase()]);
            this.getFirstElement(this.LPViewMap.device).title = this.translate('VISIT_INFO_Device_' + device.toUpperCase());
            this.showIconContiner('device_continer');
        }
    };

    EngagementViewController.prototype.showAuthChatIcon = function (data) {
        if (data && typeof data.newValue !== "undefined" && data.newValue) {
            this.showIconContiner('auth_chat_continer');
        } else {
            this.hideIconContiner('auth_chat_continer');
        }
    };

    EngagementViewController.prototype.chatInputResize = function (data) {
        this.chatView.modifyHeight(data);
    };

    EngagementViewController.prototype.setLoading = function () {
        this.removeErrorState();
        this.addClass(this.LPViewMap.engagementArea, this.LPClassesMap.loading);
    };

    EngagementViewController.prototype.removeLoading = function () {
        this.removeClass(this.LPViewMap.engagementArea, this.LPClassesMap.loading);
    };

    EngagementViewController.prototype.setEngagementAreaErrorState = function(){
        this.removeLoading();
        this.addClass(this.LPViewMap.engagementArea, this.LPClassesMap.error);
        this.chatView.resetChatView();
    };

    EngagementViewController.prototype.removeEngagementAreaErrorState = function(){
        this.removeClass(this.LPViewMap.engagementArea, this.LPClassesMap.error);
    };

    EngagementViewController.prototype.setErrorState = function () {
        this.setEngagementAreaErrorState();
        this.dropdownActionsMenu.disableDropdownButton();
    };

    EngagementViewController.prototype.removeErrorState = function () {
        this.removeEngagementAreaErrorState();
        this.dropdownActionsMenu.enableDropdownButton();
    };

    EngagementViewController.prototype.isAcceptedEngagement = function () {
        return lpTag.WebAgent.logicController.isAcceptedEngagementByChatId(this.chatId);
    };

    EngagementViewController.prototype.handleConnectionStatusChanged = function (eventData) {
        if (this.isConnectionActive()) {
            this.dropdownActionsMenu.enableDropdownButton();
        } else { //"disabled" and "notify"
            this.dropdownActionsMenu.disableDropdownButton();
        }
    };

    EngagementViewController.prototype.updateEngagementViews = function () {
        this.updateEngagementHeader();
        this.updateEngagementArea();
    };

    EngagementViewController.prototype.updateEngagementHeader = function () {
        var isAcceptedEngagement = this.isAcceptedEngagement();
        this.resetEngagementColor();
        this.resetParticipantsClassnames();
        this.resetResolvedClassnames();
        this.updateEngagementHeaderClassnames(isAcceptedEngagement);
        this.updateEngagementHeaderForMessaging();
        if (isAcceptedEngagement) {
            this.updateEngagementHeaderAcceptedEngagement();
        }
    };

    EngagementViewController.prototype.updateEngagementHeaderClassnames = function (isAcceptedEngagement) {
        this.toggleClass(this.LPViewMap.engagementHeader, this.LPClassesMap.myChat, isAcceptedEngagement);
        this.toggleClass(this.LPViewMap.engagementHeader, this.LPClassesMap.spectated, !isAcceptedEngagement);
    };

    EngagementViewController.prototype.updateEngagementAreaClassnames = function (isAcceptedEngagement) {
        this.toggleClass(this.LPViewMap.engagementArea, this.LPClassesMap.myChat, isAcceptedEngagement);
        this.toggleClass(this.LPViewMap.engagementArea, this.LPClassesMap.spectated, !isAcceptedEngagement);
    };

    EngagementViewController.prototype.updateEngagementHeaderForMessaging = function () {
        var visitorId, imageUrl;
        if (lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId, this.chatsRootModelPath)) {
            visitorId = this.visitorId || this.getModelParam(this.chatsRootModelPath + this.chatId + '.visitorInfo.visitorId');
            imageUrl = this.getModelParam(this.chatsRootModelPath + this.chatId + '.visitorInfo.imgUrl');
            this.avatar.showAvatar(visitorId, imageUrl);
            this.addClass(this.LPViewMap.engagementHeader, this.LPClassesMap.messaging);
        }
    };

    EngagementViewController.prototype.updateEngagementHeaderAcceptedEngagement = function () {
        var visitorId = this.visitorId || this.getModelParam(this.chatsRootModelPath + this.chatId + '.visitorInfo.visitorId');
        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);

        if (this.singleton) {
            this.unbindModel({ modelPath: participantPath + '.participantTag', callback: this.setEngagementColor });
        }
        this.bindModel({ modelPath: participantPath + '.participantTag', callback: this.setEngagementColor });

        // show colored visitor number for non-messaging accounts
        if (!lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId)) {
            this.getFirstElement(this.LPViewMap.visitorSerialNumber).innerHTML = this.getModelParam(participantPath + '.participantInfo.visitorSerialNumber');
        }
    };

    EngagementViewController.prototype.updateEngagementArea = function () {
        var isAcceptedEngagement = this.isAcceptedEngagement();
        this.updateEngagementAreaClassnames(isAcceptedEngagement);
    };

    EngagementViewController.prototype.updateViewComponents = function () {
        if (this.singleton) {
            this.addClass(this.LPViewMap.engagementState, this.LPClassesMap.noChatInput);
        }
    };

    EngagementViewController.prototype.hidePrivateMessageDialog = function () {
        if (this.privateMessageDialog) {
            this.privateMessageDialog.hideDialog();
        }
    };

    EngagementViewController.prototype.openEngagementClicked = function () {
        if (!lpTag.WebAgent.logicController.isInMyEngagements(this.chatId)) {
            this.modelController.openEngagement({ chatId: this.chatId });
        }
        var visitorId = this.getModelParam(this.chatsRootModelPath + this.chatId + '.visitorInfo.visitorId');
        this.viewEventsHandler.fireEvent({ appName: visitorId, UIEvent: this.eventType.VISITOR_FOCUSED });
    };

    EngagementViewController.prototype.updateTransferView = function (chatId) {
        var visitorId = this.getModelParam(this.chatsRootModelPath + chatId + '.visitorInfo.visitorId');
        var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(chatId, this.chatsRootModelPath);
        var isTransferViewNeeded = lpTag.WebAgent.logicController.isAcceptedEngagement(visitorId) || lpTag.WebAgent.logicController.isLoggedInAgentManagerParticipant(chatId, activeDialogId, this.chatsRootModelPath);
        if (!this.singleton && isTransferViewNeeded) {
            if (this.transferView && !this.transferView.disposed) {
                this.transferView.updateChatId(chatId);
            }
        }
    };

    EngagementViewController.prototype.handleAcceptedEngagement = function (data) {
        if (!data.newValue) {
            return;
        }
        this.updateEngagementViews();
        if (this.engagementState) {
            this.setEngagementState(this.engagementState);
        }
    };

    EngagementViewController.prototype.setEngagementState = function (state) {
        switch (state) {
            case this.engagementStates.active.tag :
                this.setEngagementActive();
                this.engagementState = this.engagementStates.active.tag;
                break;
            case this.engagementStates.inactive.tag :
                this.setEngagementInactiveCompleted();
                this.engagementState = this.engagementStates.inactive.tag;
                break;
            case this.engagementStates.completed.tag :
                this.setEngagementInactiveCompleted();
                this.engagementState = this.engagementStates.completed.tag;
                break;
            default :
                break;
        }

        if (this.visible) {
            this.setDropDownAndShortcuts();
        }
    };

    EngagementViewController.prototype.onWidgetsClosed = function () {
        if(lpTag.WebAgent.audioController && _.isFunction(lpTag.WebAgent.audioController.end)){
            lpTag.WebAgent.audioController.end();
        }
        this.unbindChatModel();
    };

    EngagementViewController.prototype.addFilePreviewDialog = function (data) {
        if (!this.filePreviewDialog && data && data.file) {
            this.filePreviewDialog = new FilePreviewDialogViewController({
                modelController: this.modelController,
                visitorId: this.visitorId,
                chatId: this.chatId,
                file: data.file,
                name: data.name,
                callback: data.callback
            });
            this.addViewController({
                viewController: this.filePreviewDialog,
                target: this.LPViewMap.dialogPlaceholder
            });
        } else {
            this.filePreviewDialog.setFile(data.file, data.name, data.callback);
        }
    };

    EngagementViewController.prototype.showPreview = function (data) {
        if (data && data.newValue && data.newValue.eventData && data.newValue.eventData.file) {
            this.addFilePreviewDialog(data.newValue.eventData);
        }
    };

    return EngagementViewController;

});
